import { GetStaticProps } from 'next';
import { ArticlesDownloadsPage } from 'src/modules/articles';
import { fetchPageDataSSG, PageKeys } from 'src/modules/pages';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchPageDataSSG(PageKeys.MagazinesAndBrochures);

  return { props: { page: data?.pages?.[0] || null } };
};

export default ArticlesDownloadsPage;
